import { retrying } from 'retry-ts/Task';
import { either, fromThrown, panic, pipe, taskEither } from '@code-expert/prelude';
export const invokeProcedure = (socket, { retryPolicy } = {}) => (name) => (payload) => {
    const emit = async () => {
        try {
            return await socket.emitWithAck('invoke', name, payload);
        }
        catch (e) {
            throw new Error('Failed to invoke procedure', {
                cause: {
                    procedure: name,
                    payload,
                    error: fromThrown(e),
                },
            });
        }
    };
    const retryEmit = () => (socket.connected ? emit() : panic('Retried emit while offline'));
    return retryPolicy
        ? pipe(retrying(retryPolicy, () => taskEither.tryCatch(retryEmit, fromThrown), either.isLeft), taskEither.getOrElse((cause) => panic('Network error', { cause })), taskEither.getOrElse(panic))
        : pipe(emit, taskEither.getOrElse(panic));
};
//# sourceMappingURL=invokeProcedure.js.map